export const toastErrorStyles = {
	style: {
		background: 'var(--color-black-700)',
		color: 'var(--color-red-500)',
		border: '1px solid var(--color-red-500)',
		fontSize: '14px',
		maxWidth: '300px',
		padding: '12px 16px'
	}
};

export const toastSuccessStyles = {
	style: {
		background: 'var(--color-black-700)',
		color: 'var(--color-green-500)',
		border: '1px solid var(--color-green-500)',
		fontSize: '14px',
		maxWidth: '300px',
		padding: '12px 16px'
	}
};
